__turbopack_context__.v({
  "buttonContainer": "Lu5yuG_buttonContainer",
  "buyButton": "Lu5yuG_buyButton",
  "stickyBar": "Lu5yuG_stickyBar",
  "variantButton": "Lu5yuG_variantButton",
});
